/**
 * SplitPreviewModal Component
 * Side-by-side comparison of current vs generated prompt.
 * Generated side is editable. Apply saves the generated version.
 */

import React from 'react';
import { useLanguage } from '@/hooks/useLanguage';
import ReactDOM from 'react-dom';

interface SplitPreviewModalProps {
  title: string;
  currentValue: string;
  generatedValue: string;
  onGeneratedChange: (value: string) => void;
  onApply: () => void;
  onCancel: () => void;
}

export const SplitPreviewModal: React.FC<SplitPreviewModalProps> = ({
  title,
  currentValue,
  generatedValue,
  onGeneratedChange,
  onApply,
  onCancel,
}) => {
  const { t } = useLanguage();
  return ReactDOM.createPortal(
    <div className="expand-overlay">
      <div className="expand-modal" onClick={(e) => e.stopPropagation()} style={{ width: 'min(1400px, 96vw)' }}>
        <div className="expand-modal-header">
          <h3 className="expand-modal-title">{title}</h3>
          <div className="expand-modal-actions">
            <button type="button" className="expand-btn-cancel" onClick={onCancel}>
              {t('vault.cancel')}
            </button>
            <button type="button" className="expand-btn-save" onClick={onApply}>
              {t('common.applyGenerated')}
            </button>
          </div>
        </div>
        <div style={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
          {/* Current / Previous prompt */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', borderInlineEnd: '1px solid var(--border-color, #e5e7eb)' }}>
            <div style={{
              padding: '8px 16px',
              fontSize: '11.5px',
              fontWeight: 600,
              color: 'var(--text-secondary, #667085)',
              background: 'var(--bg-secondary, #f9fafb)',
              borderBottom: '1px solid var(--border-color, #e5e7eb)',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}>
              {t('common.currentPrompt')}
            </div>
            <textarea dir="auto"
              className="expand-modal-textarea"
              value={currentValue || '(empty)'}
              readOnly
              style={{ opacity: currentValue ? 0.7 : 0.4, cursor: 'default' }}
            />
          </div>
          {/* Generated prompt (editable) */}
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <div style={{
              padding: '8px 16px',
              fontSize: '11.5px',
              fontWeight: 600,
              color: 'var(--claude-accent, #3b82f6)',
              background: 'var(--bg-secondary, #f9fafb)',
              borderBottom: '1px solid var(--border-color, #e5e7eb)',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}>
              {t('common.generatedPromptEditable')}
            </div>
            <textarea dir="auto"
              className="expand-modal-textarea"
              value={generatedValue}
              onChange={(e) => onGeneratedChange(e.target.value)}
              autoFocus
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
